class ConfigTheme {
    constructor(theme = "white") {
        this.setTheme(theme)
    }

    setMainBackground() {
        let color = "white"
        if(this.theme === 'black') {
            color = "black"
        }
        this.background = {background: color}
    }

    setMainColor() {
        let color = "white"
        if(this.theme === 'black') {
            color = "black"
        }
        this.color = {color: color}
    }

    setTheme(theme) {
        this.theme = theme
        this.setMainBackground()
        this.setMainColor()
    }

    getMainBackground() {
        return this.background;
    }

    getsetMainColor() {
        return this.color;
    }

}

export default new ConfigTheme();